import { ReactNode } from "react";

// Common components
import DoubleCheckingButton from "@Layouts/components/Buttons/DoubleCheckingButton";

interface IConfirmToolbar {
	textConfirm: string;
	icon: ReactNode;
	iconConfirm: ReactNode;
	classes: string;
	disabled: boolean;
	confirmTop: string;
	mainClasses: string;
	textClasses?: string;
	onConfirmAction: () => object;
}

function ConfirmToolbar(props: Readonly<IConfirmToolbar>) {
	const { textConfirm, icon, iconConfirm, classes, disabled, confirmTop, mainClasses, textClasses, onConfirmAction } = props;

	return (
		<DoubleCheckingButton
			title={textConfirm}
			icon={icon}
			endIcon={iconConfirm}
			confirmationButtonClasses={classes}
			confirmationButtonTextClasses={textClasses}
			disabled={disabled}
			processConfirmTop={confirmTop}
			mainButtonClasses={mainClasses}
			onDeleteAction={onConfirmAction}
		/>
	);
}

export default ConfirmToolbar;
